/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Row_CostInputs */

const en_cmp_row_cost = /** @type {(inputs: Cmp_Row_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost per feature`)
};

const id_cmp_row_cost = /** @type {(inputs: Cmp_Row_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya per fitur`)
};

/**
* | output |
* | --- |
* | "Cost per feature" |
*
* @param {Cmp_Row_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_row_cost = /** @type {((inputs?: Cmp_Row_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Row_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_row_cost(inputs)
	return en_cmp_row_cost(inputs)
});